import axios from '@/libs/api.request'

export const getConfigList = (params) => {
  return axios.request({
    method: 'get',
    params,
    url: '/tiktok/minis/config/pageConfig'
  })
}
// 获取tiktok小程序剧场短剧列表分页查询
export const getSeriesList = (params) => {
  return axios.request({
    method: 'get',
    params,
    url: '/tiktok/minis/config/pageSeriesList'
  })
}
// 新增剧场配置
export const addConfig = (data) => {
  return axios.request({
    method: 'post',
    data,
    url: '/tiktok/minis/config/addTheaterConfig'
  })
}
// 新增剧场配置关联
export const addConfigSeries = (data) => {
  return axios.request({
    method: 'post',
    data,
    url: '/tiktok/minis/config/addTheaterConfigSeriesList'
  })
}
// 删除剧场配置
export const deleteConfig = (data) => {
  return axios.request({
    method: 'delete',
    data,
    url: '/tiktok/minis/config/deleteTheaterConfig'
  })
}
// 发布
export const publishConfig = (params) => {
  return axios.request({
    method: 'get',
    params,
    url: '/tiktok/minis/config/release'
  })
}
// 更新排序
export const updateSort = (data) => {
  return axios.request({
    method: 'post',
    data,
    url: '/tiktok/minis/config/sort'
  })
}
// 删除剧场配置关联
export const deleteConfigSeries = (data) => {
  return axios.request({
    method: 'delete',
    data,
    url: '/tiktok/minis/config/deleteTheaterConfigSeriesList'
  })
}
// 查询不在剧场中的剧
export const getTheaterPlayNotIn = (params) => {
  return axios.request({
    method: 'get',
    params,
    url: '/tiktok/minis/config/play/notIn'
  })
}
// 修改剧场配置
export const updateConfig = (data) => {
  return axios.request({
    method: 'post',
    data,
    url: '/tiktok/minis/config/update'
  })
}
